import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type AssociateIncidentIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
}

export const AssociateIncidentIcon = ({
  size = 16,
  color,
  colorScheme = 'dark',
}: AssociateIncidentIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))

  return (
    <svg
      fill='none'
      height={size}
      viewBox='0 0 16 16'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      {/* Left circle */}
      <circle
        cx='4'
        cy='8'
        r='2'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      {/* Right circle */}
      <circle
        cx='12'
        cy='8'
        r='2'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      {/* Connecting line */}
      <path d='M6 8H10' stroke={resolvedColor} strokeWidth={1.5} />
    </svg>
  )
}
